

export enum UserRoles {

    PlatformAdmin = 'platform_admin',
    PlatformAuditor = 'platform_auditor',
    PlatformDeveloper = 'platform_developer',
    TenantAdmin = 'tenant_admin',
    TenantAuditor = 'tenant_auditor',
    TenantUser = "tenant_user"

}